import type { User } from "src/types/user";
import http from "./http-client";

export type APIUser = {
  id: string;
  email: string;
  email_verified: boolean;
  locale: string;
  zoneinfo?: string;
  created_at: string;
  updated_at: string;
  classic: {
    merchant_code: string;
  };
};

export const getUser = async (): Promise<User> => {
  const {
    id,
    email,
    email_verified: emailVerified,
    locale,
    zoneinfo,
    created_at: createdAt,
    updated_at: updatedAt,
  } = await http.get("/proxy/api-gateway/v0.1/user").json<APIUser>();
  return {
    id,
    email,
    emailVerified,
    locale,
    zoneinfo,
    createdAt: new Date(createdAt),
    updatedAt: new Date(updatedAt),
  };
};
